import accommodationRequestsApi from './api';

export * from './api';
export default accommodationRequestsApi;
